import { axiosPrivate } from "@app/dashboard/tools/axios/axiosInstance";

export const getMerchantPreSelectedMethods = ({ isLive }: { isLive: boolean }) => {

  const queryParams = {
    is_live: isLive
  };

  return axiosPrivate.get(`/dashboard/api/v1/payable-preselected`, { params: queryParams });
};